import styled from 'styled-components'
import { Image, Container, Segment, Grid } from 'semantic-ui-react'
import { BasedBodyContainer, BasedFullWidthBackgroundContainer } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)`
`

export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #f7f3fe;

    &&&:last-child {
        margin-bottom: 0;
    }
`

export const ThemedText = styled.span`
    color: #81439c;
`

export const BodySegment = styled(Segment)`
    && {
        font-size: 1em;
        /* margin: -1em; */
    }
`

export const IconsWrapper = styled.div`
    @media (min-width: 992px) {
        padding: 1em;
    }
    &>* {
        margin-bottom: 1em;
    }
    /* & .ui.floated.image {
        margin-right: .5em;
    }
    & .ui.right.floated.image {
        margin-right: 0;
        margin-left: .5em;
    } */
`

export const CenterText = styled.div`
    margin-bottom: 1em;
    text-align: center;
`
export const StyledSegment = styled(Segment)`
    &&&&& {
        margin: 0;
        height: fit-content;
        background-color: #81439c;
        padding: 0.1em 0.5em;
        color: #fff;
    }
`

export const LeftBorderedSegment = styled.div`
    border-left: 3px solid #81439c;
    padding-left: .3em;
    height: 100%;

`
export const LeftBorderedSegmentList = styled(LeftBorderedSegment)`
    height: auto;
    &~div {
        margin-top: .5em;
    }
`

export const CustomGrid = styled(Grid)`
    p {
        line-height: 1em;
    }
    @media (min-width: 768px) {
        &&&&& .row:nth-child(1) {
            padding-bottom: 1rem;
        }
    }
    @media (max-width: 767px) {
        p {
            margin-bottom: .5em;
        }
        &&&&& .row:nth-child(2) .column {
            padding-top: 0!important;
            &:not(:last-child) {
                padding-bottom: 0!important;
            }
        }
    }
    .flexable {
        display: flex;
        align-items: center;
    }
`

export const ImageContainer = styled.div`
    position: relative;
    height: min-content;
    margin-left: 2em;
    width: 70px;

    &&&>img {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    @media (max-width: 767px) {
        position: absolute;
        right: 1em;
        top: 180px;
        width: 90px;
        &&&>img {
            width: 100%;
        }
    }
`